@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import meineglasfaser.frontend.admin.components.layouts.AdminAuthLayout as _meineglasfaser_frontend_admin_components_layouts_AdminAuthLayout
import meineglasfaser.frontend.admin.components.layouts.AdminLayout as _meineglasfaser_frontend_admin_components_layouts_AdminLayout
import meineglasfaser.frontend.admin.pages.LandingPage as _meineglasfaser_frontend_admin_pages_LandingPage
import meineglasfaser.frontend.admin.pages.WiderrufsrechtPage as _meineglasfaser_frontend_admin_pages_WiderrufsrechtPage
import meineglasfaser.frontend.admin.pages.`external`.ExternalLahoPage as _meineglasfaser_frontend_admin_pages_external_ExternalLahoPage
import meineglasfaser.frontend.admin.pages.auth.LoginPage as _meineglasfaser_frontend_admin_pages_auth_LoginPage
import meineglasfaser.frontend.admin.pages.auth.LogoutPage as _meineglasfaser_frontend_admin_pages_auth_LogoutPage
import meineglasfaser.frontend.admin.pages.customer.CustomerListPage as _meineglasfaser_frontend_admin_pages_customer_CustomerListPage
import meineglasfaser.frontend.admin.pages.incidents.IncidentListPage as _meineglasfaser_frontend_admin_pages_incidents_IncidentListPage
import meineglasfaser.frontend.admin.pages.networks.NetworkCategoriesPage as _meineglasfaser_frontend_admin_pages_networks_NetworkCategoriesPage
import meineglasfaser.frontend.admin.pages.networks.NetworkCategoryPage as _meineglasfaser_frontend_admin_pages_networks_NetworkCategoryPage
import meineglasfaser.frontend.admin.pages.shop.AddonGroupsPage as _meineglasfaser_frontend_admin_pages_shop_AddonGroupsPage
import meineglasfaser.frontend.admin.pages.shop.OrdersPage as _meineglasfaser_frontend_admin_pages_shop_OrdersPage
import meineglasfaser.frontend.admin.pages.shop.ProductsPage as _meineglasfaser_frontend_admin_pages_shop_ProductsPage
import meineglasfaser.frontend.admin.pages.shop.ShopPage as _meineglasfaser_frontend_admin_pages_shop_ShopPage
import meineglasfaser.frontend.admin.pages.survey.SurveyDashboardPage as _meineglasfaser_frontend_admin_pages_survey_SurveyDashboardPage
import meineglasfaser.frontend.admin.pages.survey.SurveyEntriesPage as _meineglasfaser_frontend_admin_pages_survey_SurveyEntriesPage
import meineglasfaser.frontend.admin.pages.workflow.WorkflowListPage as _meineglasfaser_frontend_admin_pages_workflow_WorkflowListPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Admin Panel | Prometheus Network"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "meineglasfaser.frontend.admin.components.layouts.AdminAuthLayout",
        ) { pageCtx, pageMethod -> 
            _meineglasfaser_frontend_admin_components_layouts_AdminAuthLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx, pageMethod -> 
            _meineglasfaser_frontend_admin_components_layouts_AdminLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_LandingPage(pageCtx)
        }
        ctx.router.register(
            "/auth/login",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminAuthLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_auth_LoginPage(pageCtx)
        }
        ctx.router.register(
            "/auth/logout",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminAuthLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_auth_LogoutPage(pageCtx)
        }
        ctx.router.register(
            "/external/laho",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_external_ExternalLahoPage(pageCtx)
        }
        ctx.router.register(
            "/incidents/",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_incidents_IncidentListPage(pageCtx)
        }
        ctx.router.register(
            "/kundenstamm/",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_customer_CustomerListPage(pageCtx)
        }
        ctx.router.register(
            "/networks/",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_networks_NetworkCategoriesPage(pageCtx)
        }
        ctx.router.register(
            "/networks/{categoryId}",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_networks_NetworkCategoryPage(pageCtx)
        }
        ctx.router.register(
            "/shop/",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_shop_ShopPage(pageCtx)
        }
        ctx.router.register(
            "/shop/addon-groups",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_shop_AddonGroupsPage(pageCtx)
        }
        ctx.router.register(
            "/shop/bestellungen",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_shop_OrdersPage(pageCtx)
        }
        ctx.router.register(
            "/shop/products",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_shop_ProductsPage(pageCtx)
        }
        ctx.router.register(
            "/survey/",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_survey_SurveyDashboardPage(pageCtx)
        }
        ctx.router.register(
            "/survey/entries/{surveyId?}",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_survey_SurveyEntriesPage(pageCtx)
        }
        ctx.router.register(
            "/widerrufsrecht",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_WiderrufsrechtPage()
        }
        ctx.router.register(
            "/workflow/",
            layoutId = "meineglasfaser.frontend.admin.components.layouts.AdminLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_admin_pages_workflow_WorkflowListPage(pageCtx)
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        meineglasfaser.frontend.admin.AppEntry {
            router.renderActivePage()
        }
    }
}
